import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
export interface DropDownRowCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(isSelected:boolean, isLastIndex: boolean):object;
    getIconDivCSSStyle():object;
    getIconNameLabelCSSStyle(isEnabled:boolean):object;
    getMobileIconDivCSSStyle():object;
    getMobileIconNameLabelCSSStyle(isEnabled:boolean):object;
}

export class DropDownRowCSSStyleImpl extends UIComponentCSSStyleImpl implements DropDownRowCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
             width:'100%',
             height:'40px',
             flexFlow: "row wrap",
             display:'flex',
             flexDirection:'row',
            //  borderRadius:'0px 0px 8px 8px',
            //  margin:'1px',
             cursor:'pointer',
            //  borderRadius:'0px 0px 8px 8px',
        };
    }

    getInnerWrapperCSSStyle(isEnabled:boolean, isLastIndex: boolean):object
    {
        return{
            width:'100%',
            display:"flex",
            flexDirection:'row',
            flexFlow:'row wrap',
            borderRadius: isLastIndex ? '0px 0px 8px 8px' : '0px',
            height:'40px',
            cursor:'pointer',
            backgroundColor: isEnabled? this.getResources().getColor(Colors.color_41): this.getResources().getColor(Colors.color_5),
            // display:'inline-block'
        };
    }

    getIconDivCSSStyle():object
    {
        return{
           padding:'9px 6px 0px 6px',
           width:'10%',
           height:'100%',
           cursor:'pointer',
            
        };
    }

    getMobileIconDivCSSStyle():object
    {
        return{
            padding:'9px 0px 0px 0px',
            width:'10%',
            height:'100%',
            cursor:'pointer',
             
         };
    }
    getIconNameLabelCSSStyle(isEnabled:boolean):object
    {
        return{
            lineHeight:'40px',
            width:'90%',
            fontSize:this.getResources().getFont(Fonts.h8),
            color: isEnabled ? this.getResources().getColor(Colors.color_5) : this.getResources().getColor(Colors.color_6),
            textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"left":"left",
            cursor:'pointer',
           
         };
    }
    getMobileIconNameLabelCSSStyle(isEnabled:boolean):object
    {
        return{
            lineHeight:'40px',
            width:'90%',
            fontSize:this.getResources().getFont(Fonts.h8),
            color: isEnabled ? this.getResources().getColor(Colors.color_5) : this.getResources().getColor(Colors.color_6),
            textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"left":"left",
            cursor:'pointer',
           
         };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowcss.tsx